<template>
  <div class="ev2-box leitor">
    <div class="header">
      <div class="hcol1">
        <div class="title">Leitor de solicitações de Registro por E-mail</div>
        <div class="subtitle">Atualizado em tempo real</div>
      </div>
      <div class="hcol2">
      </div>
    </div>
    <div class="body">
      <u-table
          ref="table"
          color="primary"
          :data="table.serverData"
          :columns="table.columns"
          :visible-columns="visibledColumns"
          :filter="table.busca"
          row-key="id"
          :pagination.sync="table.serverPagination"
          @request="request"
          selection="multiple"
          :selected.sync="table.selected"
          :loading="table.loading"
          class="ev2-dash-table"
          :rows-per-page-options="[20, 50, 100]"
          :hide-no-results-label="true"
      >
        <u-tr slot="header" slot-scope="props">
          <u-th v-for="col in props.cols" :key="col.name" :props="props">
            <template>
              {{ col.label }}
            </template>
            <div v-if="col.name === 'options'" class="text-center">
            </div>
          </u-th>
        </u-tr>

        <u-tr slot="body" slot-scope="props" :props="props">
          <u-td style="max-width: 40px; min-width: 40px; width: 40px" key="id" :props="props">
            {{ props.row.id }}
          </u-td>
          <u-td class="td-limit" key="email" :props="props">
            <div class="flex items-center">

            </div>
          </u-td>
          <u-td class="" key="registro" :props="props">

          </u-td>
          <u-td class="" key="dominio" :props="props">
            {{props.row.dominio}}
          </u-td>
          <u-td class="" key="protocolo" :props="props">
            {{props.row.protocolo}}
          </u-td>
          <u-td class="" key="status" :props="props">
            Não aberto
          </u-td>
          <u-td class="text-right" key="options" :props="props">
            <div class="cursor-pointer">
              <div class="text-right no-select">Ações <i class="fa fa-chevron-down text-grey-5 font-10" /></div>
              <u-popover class="window-context-menu menu-profile min" anchor="bottom right" self="top right">
                <ul>
                  <menu-options-item close label="Abrir" @click="$emit('abrir')" />
                </ul>
              </u-popover>
            </div>
          </u-td>
        </u-tr>
      </u-table>
    </div>
<!--    <div class="footer">
      <div class="text-center">
        <u-btn class="f-btn" no-caps label="Novo Registro" />
      </div>
    </div>-->
  </div>
</template>

<script>
import ErpInput from "@/plugins/uloc-erp/components/form/input"
import ErpSelect from "@/plugins/uloc-erp/components/form/select"
import tableColumnsCache from "@/utils/tableColumnsCache"
import {UTable, UTr, UTh, UTd, date, UPopover} from "uloc-vue"
import {datePtToEn} from "@/utils/date"
import MenuOptionsItem from "components/layout/context-menu/context-window-options-item.vue";

let filters = {
  id: null,
}

const listName = 'table.fenaju.leitorDash'
const listStorage = tableColumnsCache(listName, [
  {label: 'ID', name: 'id', active: false, sortable: true, ordering: 1},
  {label: 'E-mail', name: 'email', active: true, sortable: true, ordering: 1},
  {label: 'Registro', name: 'registro', active: true, sortable: true, ordering: 1},
  {label: 'Domínio', name: 'dominio', active: true, sortable: true, ordering: 1},
  {label: 'Protocolo', name: 'protocolo', active: true, sortable: true, ordering: 1},
  {label: 'Situação', name: 'status', active: true, sortable: true, ordering: 1},
], 1)
export default {
  name: "Leitor",
  components: {
    MenuOptionsItem,
    //ErpSelect,
    //ErpInput,
    UTable, UTr, UTh, UTd, UPopover
  },
  data () {
    const filtros = JSON.parse(JSON.stringify(filters))
    return {
      busca: null,
      buscaTipo: 'pendentes',
      buscaTipoOpts: [
        {label: 'Com pendência', value: 'pendentes'},
      ],
      listStorage: listStorage,
      table: {
        busca: '',
        serverData: [],
        serverPagination: {
          page: 1,
          rowsNumber: 0, // specifying this determines pagination is server-side
          rowsPerPage: 20
        },
        columns: listStorage.map(o => {
          return {
            ...o,
            field: o.name,
            align: 'left'
          }
        }).concat([
          {
            name: 'options',
            required: true,
            label: '',
            field: 'options',
            sortable: false
          }
        ]),
        filter: '',
        filters: filtros,
        selected: [],
        loading: false
      },
      mock: [
        {
          pessoa: {
            id: 1,
            name: 'João Marcos'
          },
          matriculas: 'MG',
          dominio: 'Em desenvolvimento. V2',
          status: 0
        },
      ]
    }
  },
  mounted() {
    this.load()
  },
  computed: {
    visibledColumns() {
      return this.listStorage.filter(item => item.active).map(item => item.name)
    }
  },
  methods: {
    load () {
      this.request({
        pagination: this.table.serverPagination,
        filter: this.table.busca
      })
    },
    request({pagination, filter}, exportar = null) {

      // this.table.serverPagination.rowsNumber = 0

      let data1, data2
      let extraFilters = []

      if (this.table.filters.data1) {
        if (this.table.filters.data1.length < 10 || this.table.filters.data2.length < 10) {
          alert('Digite a data inicial e data final corretamente para o filtro de entrada.')
          return
        }

        data1 = datePtToEn(this.table.filters.data1)
        data2 = datePtToEn(this.table.filters.data2)
        if (!date.isValid(data1) || !date.isValid(data2)) {
          alert('Digite a data inicial e data final corretamente. Formato: dd/mm/yyyy')
          return
        }
        extraFilters.push(`&data1=${data1}&data2=${data2}`)
      }

      this.table.filters.tipoData && extraFilters.push(`&typeDate=${this.table.filters.tipoData}`)

      this.table.filters.id && extraFilters.push(`&id=${this.table.filters.id}`)
      this.table.filters.search && extraFilters.push(`&search=${this.table.filters.search}`)

      if (Array.isArray(this.table.filters.status) && this.table.filters.status.length > 0) {
        extraFilters.push(`&status=${this.table.filters.status.join(',')}`)
      }

      this.table.filters.pessoa && extraFilters.push(`&pessoa=${this.table.filters.pessoa.id || this.table.filters.pessoa}`)
      this.table.filters.status && extraFilters.push(`&status=${this.table.filters.status}`)

      if (exportar) {
        extraFilters.push(`&export=${exportar}`)
      }

      this.table.loading = true
      let _filter = this.filtros
      let filtros = encodeURI(`&sortBy=${pagination.sortBy || 'createdAt'}&descending=${pagination.sortBy ? (pagination.descending ? 'true' : 'false') : (this.listType === 'ativos' ? 'false' : true)}&${extraFilters.join('')}`)

      setTimeout(() => {
        this.table.serverPagination = pagination
        this.table.serverPagination.rowsNumber = 10
        this.table.serverData = this.mock
        this.table.loading = false
      }, 1000)

      /*list(pagination.rowsPerPage, pagination.page, filtros, exportar)
          .then((response) => {
            if (exportar) {
              donwloadFile(response)
              this.table.loading = false
              return
            }
            const data = response.data
            this.table.serverPagination = pagination
            this.table.serverPagination.rowsNumber = data.total
            this.table.serverData = data.result
            this.table.loading = false
          })
          .catch(error => {
            this.alertApiError(error)
            this.loading = false
          })*/
    },
  }
}
</script>
